module.exports = __webpack_public_path__ + "img/answer_5.700cdd55.png";